'use client'

import type { FC } from 'react'
import type { UserProfileProps } from './types'
import clsx from 'clsx'
import { Avatar, Popover, Typography } from '@sylveraio/design-system'
import { UserProfileDropdown } from './UserProfileDropdown'
import { Logout } from './Logout'

export const UserProfile: FC<UserProfileProps> = ({
  testId = 'user-profile',
  initials,
  organisation,
  currentTier,
  collapsed,
}) => (
  <div
    data-testid={testId}
    className={clsx(
      'flex items-center w-full py-2 transition-all duration-250',
      {
        'justify-start pl-3 pr-4 gap-x-3': !collapsed,
        'justify-center': collapsed,
      },
    )}
  >
    <Popover
      popoverOffset={10}
      placement="right"
      content={
        collapsed && (
          <UserProfileDropdown
            initials={initials}
            organisation={organisation}
            currentTier={currentTier}
          />
        )
      }
      disable={!collapsed}
    >
      <span data-testid={`${testId}-avatar`}>
        {initials && (
          <Avatar
            initials={initials}
            background="bg-low"
            textClassName="text-default"
            removeHoverEffect={!collapsed}
          />
        )}
      </span>
    </Popover>

    {!collapsed && (
      <>
        <div className="mr-auto flex flex-1 flex-col items-start justify-center">
          {organisation && (
            <Typography
              testId={`${testId}-organisation`}
              size="xs"
              weight="medium"
              className="max-w-32 truncate"
            >
              {organisation}
            </Typography>
          )}
          {/* Removed until we determine how to show new Pricing Plans */}
          {/* {currentTier && (
            <Typography
              testId={`${testId}-tier`}
              size="xs"
              weight="regular"
              className="text-subtle"
            >
              {currentTier}
            </Typography>
          )} */}
        </div>
        <Logout />
      </>
    )}
  </div>
)
